export function formatCurrency(amount: number): string {
  if (amount === 0) return '₹0';
  const abs = Math.abs(amount);
  const formatted = new Intl.NumberFormat('en-IN').format(abs);
  return amount < 0 ? `-₹${formatted}` : `₹${formatted}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateRelative(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const diffDays = Math.floor(
    (now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24)
  );
  if (diffDays <= 7) return `${diffDays}d ago`;
  if (diffDays <= 30) return `${Math.floor(diffDays / 7)}w ago`;
  return formatDate(iso);
}
